// extracted by mini-css-extract-plugin
export default {"warningBanner":"WarningBanner_warningBanner__lVGw5","icon":"WarningBanner_icon__CwxUP","content":"WarningBanner_content__b9tWN","iconClose":"WarningBanner_iconClose__KL55a"};